<a
    mat-stroked-button
    class="lvc-request-button"
    [href]="href"
    target="_blank"
    rel="noopener noreferrer"
    [matTooltip]="tooltip"
    matTooltipPosition="above"
    [attr.aria-label]="label + ' (opens in a new tab)'"
>
    <mat-icon>open_in_new</mat-icon>
    {{ label }}
</a>
